import React from "react";
import { Link } from "react-router-dom";
import { Wrench, MapPin, MessageCircle, FileText } from "lucide-react";
import { supportWaLink } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { POLICY_LIST } from "@/lib/policies";

const QUICK = [
  ["/", "الرئيسية"], ["/about", "عن المنصة"], ["/how-it-works", "كيف تعمل المنصة"],
  ["/yards", "التشاليح"], ["/search", "قطع الغيار"], ["/contact", "تواصل معنا"], ["/faq", "الأسئلة الشائعة"],
];

export const Footer = () => {
  const s = useSettings();
  return (
    <footer className="mt-20 border-t bg-[var(--bg-secondary)]" style={{ borderColor: "var(--border-c)" }}>
      <div className="mx-auto max-w-7xl px-6 py-14 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[var(--amber)] text-[#0B0F17]"><Wrench size={22} /></span>
            <span className="font-head text-2xl font-black text-white">{s.platform_name}</span>
          </div>
          <ul className="space-y-2 text-sm text-[var(--text-muted)]">
            <li className="flex items-center gap-2"><MapPin size={15} className="text-[var(--amber)]" /> {s.address}</li>
            <li className="flex items-center gap-2"><MessageCircle size={15} className="text-[var(--amber)]" /> دعم واتساب: {s.support_whatsapp}</li>
          </ul>
          <a data-testid="footer-support-whatsapp" href={supportWaLink()} target="_blank" rel="noopener noreferrer"
            className="mt-4 inline-flex items-center gap-2 rounded-xl bg-[#25D366] px-4 py-2.5 text-sm font-bold text-white hover:bg-[#1ebe57] transition-colors">
            <MessageCircle size={16} /> دعم واتساب
          </a>
        </div>

        <div>
          <h4 className="font-bold text-white mb-4">روابط سريعة</h4>
          <ul className="space-y-2 text-sm text-[var(--text-muted)]">
            {QUICK.map(([to, label]) => (
              <li key={to}><Link to={to} className="hover:text-[var(--amber)]">{label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-bold text-white mb-4 flex items-center gap-2"><FileText size={16} className="text-[var(--amber)]" /> السياسات والأنظمة</h4>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm text-[var(--text-muted)]">
            {POLICY_LIST.map(([slug, title]) => (
              <li key={slug}>
                <Link data-testid={`footer-policy-${slug}`} to={`/policy/${slug}`}
                  className={`hover:text-[var(--amber)] ${slug === "returns" ? "text-[var(--amber)] font-bold" : ""}`}>{title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t py-6 text-center text-xs text-[var(--text-muted)]" style={{ borderColor: "var(--border-c)" }}>
        © 2026 {s.platform_name} — جميع الحقوق محفوظة. لا نأخذ أي عمولة على مبيعات القطع.
      </div>
    </footer>
  );
};
